export default "__VITE_ASSET__94ef7a13__"